module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/responsible/responsible-datatable/responsible-datatable.component.css
// module id = ./src/app/components/responsible/responsible-datatable/responsible-datatable.component.css
// module chunks = main